// Split per-locale bundles. `es` is the reference: every other locale must
// define the same key set (checked by `npm run check:i18n`). Missing strings
// fall back per i18next config in src/lib/i18n.ts.

import { es } from './es'
import { ca } from './ca'
import { eu } from './eu'
import { gl } from './gl'
import { en } from './en'
import { de } from './de'
import { fr } from './fr'
import { it } from './it'
import { pt } from './pt'

export const resources = { es, ca, eu, gl, en, de, fr, it, pt } as const

export type Resources = typeof resources
